import { render, staticRenderFns } from "./GatewaysView.vue?vue&type=template&id=098def0b&scoped=true&"
import script from "./GatewaysView.vue?vue&type=script&lang=js&"
export * from "./GatewaysView.vue?vue&type=script&lang=js&"
import style0 from "./GatewaysView.vue?vue&type=style&index=0&id=098def0b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "098def0b",
  null
  
)

export default component.exports